<template>
  <div class="common-page order-reassignment">
    <div class="tab-box">
      <custom-tab-box :tabData="tabData" @change="handleChangeTab" :selectTab="selectTab"></custom-tab-box>
    </div>
    <div class="search-form-box">
      <waybill-review v-if="selectTab === 1" @success="getNum"></waybill-review>
      <shipping-order-verification v-if="selectTab === 2" @success="getNum"></shipping-order-verification>
      <third-party-order v-if="selectTab === 3" @success="getNum"></third-party-order>
    </div>
  </div>
</template>

<script>
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import WaybillReview from "./components/waybillReview.vue";
import shippingOrderVerification from "./components/shippingOrderVerification.vue";
import thirdPartyOrder from "./components/thirdPartyOrder.vue";
import { getPricingBacklog } from "@/views/CustomerServiceWorkbench/PendingPriceOrder/api";
export default {
  name: "OrderManagement",
  components: {
    WaybillReview,
    thirdPartyOrder,
    shippingOrderVerification,
    CustomTabBox,
  },
  data() {
    return {
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "运费审核",
          num: 0
        },
        {
          label: 2,
          value: "运单核价",
          num: 0
        },
        {
          label: 3,
          value: "第三方平台订单跟单",
          num: 0
        },
      ],
      time: null
    };
  },
  created() {
    this.getNum()
    this.time = setInterval(() => {
      this.getNum()
    }, 10000)
  },
  mounted() {},
  beforeDestroy() {
    if (this.time) {
      clearInterval(this.time)
      this.time = null
    }
  },
  methods: {
    getNum() {
      getPricingBacklog().then((res) => {
        if (res.code === 200) {
          this.tabData[0].num = res.data.unConfirm;
          this.tabData[1].num = res.data.noFee;
          this.tabData[2].num = res.data.outsideNum;
        }
      })
    },
    handleChangeTab(val) {
      this.selectTab = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.order-reassignment {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  .tab-box{
    flex-shrink: 0;
    padding: 15px;
    box-sizing: border-box;
  }
  .search-form-box{
    flex: 1;
    padding-top: 0;
    overflow: hidden;
  }
}
</style>
